import React, { useEffect, useState } from 'react'

// @Mui Imports
import Autocomplete from '@mui/material/Autocomplete'
import Box from '@mui/material/Box'
import FormControl from '@mui/material/FormControl'
import Grid from '@mui/material/Grid'
import TextField from '@mui/material/TextField'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { Button, InputLabel, MenuItem, Paper, Select } from '@mui/material'
import moment from 'moment'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import API from '../../../services/API'
import Quill from '../../../components/Quill'
import SmallModal from '../../../components/Modals/SmallModal'
import SuccessModal from '../../../components/Modals/Success'
import ErrorModal from '../../../components/Modals/Error'
import AssignedTo from '../../../components/Tasks/AssignedTo'
import AnDatePicker from '../../../components/DateTime/DatePicker'
import TipTap from '../../../components/TipTap/TipTap'

const AddNewTask = ({
  passedEvent,
  passedSafetyAlert,
  successAction,
  onClose,
}) => {
  const [type, setType] = useState('Phone Call')
  const [dueDate, setDueDate] = useState(moment())
  const [priority, setPriority] = useState('Medium')
  const [assignedTo, setAssignedTo] = useState('')
  const [subject, setSubject] = useState(
    passedSafetyAlert ? 'Safety Alert' : '',
  )
  const [body, setBody] = useState('')
  const [submitSuccess, setSubmitSuccess] = useState(false)
  const [submitError, setSubmitError] = useState(false)

  const handleSubmit = (e) => {
    e.preventDefault()
    if (!body) {
      alert('Task Body cannot be empty!')
    } else {
      API.post('/task', {
        taskName: subject,
        taskDescription: body,
        taskStatus: 'New',
        taskComplete: false,
        assignedToUser: typeof assignedTo === 'object' ? assignedTo : null,
        assignedToTeam: typeof assignedTo === 'string' ? assignedTo : null,
        dueDate,
        // Stored as the label ('Urgent' | 'High' | 'Medium' | 'Low') — older
        // tasks hold 1–4 here, which taskHelpers.normalisePriority maps back
        taskPriority: priority,
        links: {
          event: passedEvent?._id,
          safetyAlert: passedSafetyAlert,
        },
      })
        .then((res) =>
          res.status === 200
            ? successAction
              ? successAction(res.data)
              : setSubmitSuccess(true)
            : setSubmitError(true),
        )
        .catch((e) => setSubmitError(true))
    }
  }
  return (
    <Box component={Paper} padding={3}>
      <Box
        display="flex"
        flexDirection="column"
        gap={2}
        component="form"
        onSubmit={handleSubmit}
        width="100%"
      >
        <Typography variant="title2">New Task</Typography>
        <Grid container padding={1} columnSpacing={1} rowSpacing={2}>
          <Grid item xs={12} lg={5}>
            <AssignedTo
              value={assignedTo}
              onChange={(e, value) => setAssignedTo(value)}
            />
          </Grid>
          <Grid item xs={12} lg={7}>
            <TextField
              fullWidth
              required
              value={subject}
              autoComplete="off"
              onChange={(e) => setSubject(e.target.value)}
              label="Subject"
            />
          </Grid>
          <Grid item xs={12} lg={4}>
            <FormControl fullWidth required>
              <Autocomplete
                options={['Phone Call', 'Email', 'Follow Up']}
                onChange={(e, value) => setType(value)}
                defaultValue="Phone Call"
                freeSolo
                value={
                  passedEvent
                    ? 'Event'
                    : passedSafetyAlert
                      ? 'Safety Alert'
                      : type
                }
                isOptionEqualToValue={(option, value) =>
                  passedEvent || passedSafetyAlert ? true : option === value
                }
                disabled={!!passedEvent || !!passedSafetyAlert}
                renderInput={(params) => <TextField {...params} label="Type" />}
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} lg={4}>
            <AnDatePicker
              label="Due Date"
              value={dueDate}
              fullWidth
              onChange={(newDate) => setDueDate(newDate)}
            />
          </Grid>
          <Grid item xs={12} lg={4}>
            <FormControl fullWidth>
              <InputLabel id="priority-label">Priority</InputLabel>
              <Select
                labelId="priority-label"
                label="Priority"
                value={priority}
                onChange={(e) => setPriority(e.target.value)}
              >
                <MenuItem value="Urgent">Urgent</MenuItem>
                <MenuItem value="High">High</MenuItem>
                <MenuItem value="Medium">Medium</MenuItem>
                <MenuItem value="Low">Low</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <Box>
              <TipTap value={body} onChange={setBody} />
            </Box>
          </Grid>
          <Grid item xs={12} display="flex" justifyContent="flex-end" gap={1}>
            {onClose && (
              <Button variant="outlined" color="anRed" onClick={onClose}>
                Cancel
              </Button>
            )}
            <Button type="submit" variant="contained" color="primary">
              Submit
            </Button>
          </Grid>
        </Grid>
        <SuccessModal newUrl="/tasks/new" open={submitSuccess} />
        <ErrorModal open={submitError} onClose={() => setSubmitError(false)} />
      </Box>
    </Box>
  )
}

export default AddNewTask
